var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fb-demo" }, [
    _c(
      "aside",
      { staticClass: "fb-demo__sidebar" },
      [
        _c("h5", { staticClass: "fb-demo__title" }, [
          _vm._v("PDF Form Builder — Demo")
        ]),
        _c(
          "div",
          { staticClass: "fb-demo__mode" },
          [
            _c(
              "b-button",
              {
                attrs: {
                  size: "sm",
                  variant: _vm.mode === "editor" ? "primary" : "outline-primary"
                },
                on: {
                  click: function($event) {
                    _vm.mode = "editor"
                  }
                }
              },
              [_vm._v(" Editor ")]
            ),
            _c(
              "b-button",
              {
                attrs: {
                  size: "sm",
                  variant: _vm.mode === "fill" ? "primary" : "outline-primary",
                  disabled: !_vm.fields.length
                },
                on: {
                  click: function($event) {
                    _vm.mode = "fill"
                  }
                }
              },
              [_vm._v(" Completar ")]
            )
          ],
          1
        ),
        _c("label", { staticClass: "fb-demo__label" }, [_vm._v("URL del PDF")]),
        _c(
          "div",
          { staticClass: "fb-demo__url" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.urlInput,
                  expression: "urlInput"
                }
              ],
              staticClass: "fb-demo__input",
              attrs: { type: "text", placeholder: "https://.../documento.pdf" },
              domProps: { value: _vm.urlInput },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.urlInput = $event.target.value
                }
              }
            }),
            _c(
              "b-button",
              {
                attrs: { size: "sm", variant: "primary" },
                on: { click: _vm.loadUrl }
              },
              [_vm._v("Cargar")]
            )
          ],
          1
        ),
        _vm.mode === "editor"
          ? [
              _c("label", { staticClass: "fb-demo__label" }, [
                _vm._v("Tipo de campo a crear")
              ]),
              _c(
                "div",
                { staticClass: "fb-demo__palette" },
                _vm._l(_vm.fieldTypeList, function(t) {
                  return _c(
                    "b-button",
                    {
                      key: t.type,
                      staticClass: "fb-demo__palette-btn",
                      attrs: {
                        size: "sm",
                        variant:
                          t.type === _vm.activeFieldType
                            ? "primary"
                            : "outline-primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleType(t.type)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(t.label) + " ")]
                  )
                }),
                1
              ),
              _c(
                "p",
                { staticClass: "fb-demo__hint" },
                [
                  _vm.activeFieldType
                    ? [
                        _vm._v(" Haz click sobre el PDF para crear un campo "),
                        _c("strong", [_vm._v(_vm._s(_vm.activeLabel))]),
                        _vm._v(". Se agrega de a uno. ")
                      ]
                    : [_vm._v(" Selecciona un tipo para agregar un campo. ")]
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "fb-demo__actions" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "outline-danger" },
                      on: { click: _vm.clearFields }
                    },
                    [_vm._v(" Vaciar campos ")]
                  ),
                  _c("span", { staticClass: "fb-demo__count" }, [
                    _vm._v(_vm._s(_vm.fields.length) + " campo(s)")
                  ])
                ],
                1
              ),
              _c("label", { staticClass: "fb-demo__label" }, [
                _vm._v("Campos agregados")
              ]),
              _c("FieldListPanel", {
                staticClass: "fb-demo__list",
                attrs: { fields: _vm.fields, "selected-id": _vm.selectedId },
                on: {
                  select: function($event) {
                    _vm.selectedId = $event
                  },
                  delete: _vm.deleteField,
                  update: _vm.updateField
                }
              }),
              _c("label", { staticClass: "fb-demo__label" }, [
                _vm._v("template.json (en puntos PDF)")
              ]),
              _c("pre", { staticClass: "fb-demo__json" }, [
                _vm._v(_vm._s(_vm.templateJson))
              ])
            ]
          : [
              _c("p", { staticClass: "fb-demo__hint" }, [
                _vm._v(
                  " Completa los campos definidos en la plantilla. Los valores se guardan aparte, sin modificar la definición de campos. "
                )
              ]),
              _c("label", { staticClass: "fb-demo__label" }, [
                _vm._v("values (por id de campo)")
              ]),
              _c("pre", { staticClass: "fb-demo__json" }, [
                _vm._v(_vm._s(_vm.valuesJson))
              ])
            ]
      ],
      2
    ),
    _c(
      "main",
      { staticClass: "fb-demo__main" },
      [
        _vm.src
          ? [
              _c("PdfFieldEditor", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mode === "editor",
                    expression: "mode === 'editor'"
                  }
                ],
                attrs: {
                  active: _vm.mode === "editor",
                  s3url: _vm.src,
                  "active-field-type": _vm.activeFieldType,
                  "allowed-field-types": _vm.allowedFieldTypes,
                  "selected-id": _vm.selectedId,
                  name: "demo.pdf"
                },
                on: {
                  "update:selectedId": function($event) {
                    _vm.selectedId = $event
                  },
                  "update:selected-id": function($event) {
                    _vm.selectedId = $event
                  },
                  "field-created": _vm.onFieldCreated
                },
                model: {
                  value: _vm.fields,
                  callback: function($$v) {
                    _vm.fields = $$v
                  },
                  expression: "fields"
                }
              }),
              _c("PdfFormViewer", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mode === "fill",
                    expression: "mode === 'fill'"
                  }
                ],
                attrs: {
                  active: _vm.mode === "fill",
                  fields: _vm.fields,
                  s3url: _vm.src,
                  name: "demo.pdf"
                },
                model: {
                  value: _vm.values,
                  callback: function($$v) {
                    _vm.values = $$v
                  },
                  expression: "values"
                }
              })
            ]
          : _c("div", { staticClass: "fb-demo__empty" }, [
              _vm._v(" Pega una URL de PDF y pulsa «Cargar». ")
            ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }